import { render } from "./courseMenu.vue?vue&type=template&id=32bddff4&scoped=true"
import script from "./courseMenu.vue?vue&type=script&lang=js"
export * from "./courseMenu.vue?vue&type=script&lang=js"

import "./courseMenu.vue?vue&type=style&index=0&id=32bddff4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bddff4"]])

export default __exports__